import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    card_container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px',
        border: `1px solid ${theme.palette.grey[200]}`,
        padding: '16px',
    },
    header_container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '10px',
        marginBottom: '8px',
    },
    version_info_container: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    version_text: {
        fontSize: '17px',
        fontWeight: 700,
    },
    latest_badge: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        fontSize: '11px',
        fontWeight: 700,
        textTransform: 'uppercase',
        borderRadius: '12px',
        padding: '2px 10px',
    },
    changes_list: {
        margin: '0',
        paddingLeft: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
}));

export {useStyles}
